/**
 * Granel Vital — CTA visible de la tarjeta de producto ("Elegir presentación").
 *
 * El tema trae un quick-add nativo, pero es un botón circular que aparece al
 * pasar el cursor sobre la imagen: invisible en móvil y fácil de no descubrir
 * en escritorio. El mockup pide un botón permanente al pie de la card.
 *
 * Contrato pixel-safe: este componente NO agrega al carrito ni abre modales
 * propios. Solo reenvía el clic al botón nativo del quick-add de su misma
 * tarjeta, que es quien dispara los eventos estándar de Shopify. Si por lo que
 * sea no encuentra ese botón, deja pasar la navegación a la ficha del producto.
 */
class GvCardCta extends HTMLElement {
  connectedCallback() {
    this.#trigger = this.querySelector('[data-gv-card-cta]');
    if (!this.#trigger) return;

    this.#trigger.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.#trigger?.removeEventListener('click', this.#handleClick);
  }

  /** @type {HTMLElement | null} */
  #trigger = null;

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    const card = this.closest('product-card');
    if (!card) return;

    // Se prefiere "elegir opciones" (abre el modal con el selector de
    // presentación); si el producto tiene una sola variante, el tema solo
    // renderiza el botón de agregar y ese es el correcto.
    const native =
      card.querySelector('.quick-add__button--choose') ?? card.querySelector('.quick-add__button--add');

    if (!(native instanceof HTMLElement)) {
      // Sin quick-add disponible el enlace de la card hace su trabajo normal.
      return;
    }

    event.preventDefault();
    native.click();
  };
}

if (!customElements.get('gv-card-cta')) {
  customElements.define('gv-card-cta', GvCardCta);
}
